import { useId } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Label, Switch } from "@athena/ui";
import { ALUMNI_ROOT, isAlumniPath, useShellAccess } from "@/lib/adminPilot";

/**
 * Moves a platform ADMIN in the pilot org between the admin portal and the alumni console. On
 * while they are in the console. Draws nothing for anyone held to one shell — coordinators stay in
 * the console and everyone else in the portal (see `AdminPilotGate`).
 */
export function ShellSwitch() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const access = useShellAccess();
    const id = useId();

    if (access !== "both") return null;

    return (
        <div className="flex items-center justify-between gap-2 px-2 group-data-[collapsible=icon]:hidden">
            <Label htmlFor={id} className="text-sidebar-foreground text-sm">
                {t("admin.alumni.consoleSwitch")}
            </Label>
            <Switch
                id={id}
                checked={isAlumniPath(pathname)}
                onCheckedChange={(on) => navigate(on ? ALUMNI_ROOT : "/")}
            />
        </div>
    );
}
